import { RefObject } from "react";

import { Typography } from "@mui/material";

import noAvatarImage from "../../../../imagenes/no_avatar.svg";
import { TProgressSummary } from "../../hooks/useMyCourseInstructor";
import { TFinishedSummaryDialogRef } from "./FinishedSummaryDialog";

export type TGraduatedSummaryItemProps = {
	finishedSummary: TProgressSummary;
	finishedSummaryRef: RefObject<TFinishedSummaryDialogRef | null>;
};

export function FinishedSummaryItem({
	finishedSummary,
	finishedSummaryRef,
}: TGraduatedSummaryItemProps) {
	const student = finishedSummary.student;
	const studentName = `${student.firstName} ${student.lastName}`.trim();

	const open = () => {
		finishedSummaryRef.current?.open(finishedSummary);
	};

	return (
		<>
			<div className="finished-summary-item-container" onClick={open}>
				<img
					src={
						student.profile?.thumbnail || student.profile?.url || noAvatarImage
					}
					className="avatar"
				/>
				<Typography
					className="big-text bold item-separator-small"
					textAlign="center">
					{studentName}
				</Typography>
			</div>
		</>
	);
}
